import axiosInstance from './axiosConfig';

const designationService = {
  getAll: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/designations?page=${page}&limit=${limit}`);
    return Array.isArray(response.data) ? response.data : response.data.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/designations/${id}`);
    return response.data;
  },

  getActive: async () => {
    const response = await axiosInstance.get("/designations/active");
    return response.data.data.map(des => ({
      value: des.id,
      text: des.name,
    }));
  },

  create: async (data) => {
    const response = await axiosInstance.post('/designations/create', {
      designations: [data]
    });
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/designations/edit/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/designations/delete/${id}`);
    return response.data;
  },

  filter: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);

    const response = await axiosInstance.get(
      params.toString()
        ? `/designations?${params.toString()}`
        : '/designations'
    );
    return response.data;
  },
};

export default designationService;
